export const expandedPermissionModalTabs: IExpandedPermissionModalTabs = {
  permissions: 'Permissions',
  users: 'Users',
};

export interface IExpandedPermissionModalTabs {
  permissions: string;
  users: string;
};
